<template>
  <Popover>
    <Float
      v-if="user"
      placement="top-start"
      vue-transition
      transition-name="slide-fade-from-bottom"
    >
      <PopoverButton
        class="dropdown-toggle group block w-full flex-shrink-0 focus:outline-none"
      >
        <div class="flex items-center">
          <UserAvatar
            v-if="user.first_name || user.last_name"
            :user="user"
            size="medium"
            class="shrink-0"
          />
          <div class="ml-3 hidden @3xs/menu:block">
            <p
              v-show="!collapsedMenu || expanded"
              class="truncate text-sm font-bold text-white"
            >
              {{ user.full_name }}
            </p>
          </div>
        </div>
      </PopoverButton>

      <PopoverPanel
        class="z-10 mb-3"
        :class="
          expanded ? 'w-[calc(100vw-2.5rem)] max-w-sm' : 'w-56 px-4 sm:px-0'
        "
      >
        <div class="box dark:bg-gray-700 dark:text-slate-200">
          <div
            class="flex flex-col gap-0.5 border-b border-black/5 p-4 dark:border-slate-700"
          >
            <div class="font-medium">{{ user.full_name }}</div>
            <div class="truncate text-xs text-gray-600 dark:text-gray-300">
              {{ user.email }}
            </div>
            <div class="text-xs text-gray-600 dark:text-gray-300">
              {{ $t('global.version') }}: {{ packageVersion }}
            </div>
          </div>

          <div class="p-2">
            <RouterLink
              :to="{ name: 'profile_form_route' }"
              class="flex items-center rounded-md p-2 capitalize-first transition-opacity duration-300 ease-in-out hover:bg-gray-200 dark:hover:bg-slate-400"
            >
              <FontAwesomeIcon :icon="['fal', 'user']" class="mr-2" />
              <div class="inline-block capitalize-first">
                {{ $t('global.my_profile') }}
              </div>
            </RouterLink>
          </div>

          <div
            class="flex justify-center gap-3 border-t border-black/5 p-2 dark:border-slate-700"
          >
            <BaseButton
              v-for="locale in locales"
              :key="locale.code"
              size="small"
              :title="locale.label"
              :color="currentLocale === locale.code ? 'primary' : 'light'"
              @click="$i18n.locale = locale.code"
            />
          </div>

          <div class="border-t border-black/5 p-2 dark:border-slate-700">
            <a
              href=""
              class="flex items-center gap-2 rounded-md p-2 transition-opacity duration-300 ease-in-out hover:bg-gray-200 dark:hover:bg-slate-400"
              @click.prevent="refreshAuthHandler"
            >
              <FontAwesomeIcon fixed-width :icon="['fal', 'sync-alt']" />
              <span>DEBUG: refresh auth</span>
            </a>
            <TheDarkModeSwitcher2 />
          </div>
          <div class="border-t border-black/5 p-2 dark:border-slate-700">
            <a
              href=""
              class="flex items-center gap-2 rounded-md p-2 transition-opacity duration-300 ease-in-out hover:bg-gray-200 dark:hover:bg-slate-400"
              @click.prevent="handleLogout"
            >
              <FontAwesomeIcon fixed-width :icon="['fal', 'sign-out']" />
              <span>Logout</span>
            </a>
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'
import TheDarkModeSwitcher2 from '@c/layouts/dark-mode-switcher/TheDarkModeSwitcher2.vue'
import UserAvatar from '@c/Avatar/UserAvatar.vue'

export default {
  name: 'InfoUserModalComponent',
  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    Float,
    FontAwesomeIcon,
    TheDarkModeSwitcher2,
    UserAvatar
  },
  props: {
    expanded: { type: Boolean, default: false }
  },
  data() {
    return {
      locales: [
        { code: 'nl_BE', label: 'Nederlands' },
        { code: 'fr_BE', label: 'Français' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/getAuth',
      packageVersion: 'settings/getPackageVersion'
    }),
    ...mapGetters('sideMenu', ['collapsedMenu']),
    currentLocale() {
      return this.$i18n.locale
    }
  },
  methods: {
    refreshAuthHandler() {
      this.$store.dispatch('auth/refreshAuth')
    },
    async handleLogout() {
      await this.$store.dispatch('auth/logout')
    }
  }
}
</script>
